import React from 'react'
import { Form } from 'react-bootstrap'

function Types({ TypesProps }) {
    const { uniqueTypes = [], typeChangeHandler } = TypesProps

    return (
        <Form.Select className='flex-one' aria-label='Default select example' defaultValue={'DEFAULT'} onChange={typeChangeHandler}>
            <option hidden value='DEFAULT' disabled>Select a type...</option>
            {Object.keys(uniqueTypes).map(key => <option value={key} key={key}>{uniqueTypes[key].display}</option>)}
        </Form.Select>
    )
}

export default Types